import request from '@/utils/request'
import VueCookies from 'vue-cookies'


// 获取首页的商品分类
export function getTypeList() {
  return request({
    url: '/goods/getTypeList',
    method: 'get'
  })
}


// 获取轮播图
export function getbannerList(data) {
  return request({
    url: '/banner/getList',
    method: 'get',
	params:data
  })
}


// 获取商品分类列表
export function getCateList(data) {
  return request({
    url: '/goodsType/getList',
    method: 'get',
	params:data
  })
}


// 获取商品列表数据
export function getGoodslist(data) {
  return request({
    url: '/goods/getList',
    method: 'post',
	data:data
  })
}



// 获取商品详情
export function getGoodsInfo(data) {
  return request({
    url: '/goods/getDetail',
    method: 'get',
	params:data
  })
}


// 获取购物车列表
export function getShoppingCartList() {
  return request({
    url: '/shoppingCart/getShoppingCartList',
    method: 'get'
  })
}


// 获取热门搜索词
export function hotKeywords() {
  return request({
    url: '/hotKeywords/getList',
    method: 'get'
  })
}

// 获取优惠券中心
export function couponList() {
  return request({
    url: '/coupon/getList',
    method: 'get'
  })
}

// 领取优惠券
export function couponReceive(data) {
  return request({
    url: '/userCoupon/receive',
    method: 'post',
	data:data
  })
}


// 获取常见问题
export function qaList() {
  return request({
    url: '/qa/getList',
    method: 'get'
  })
}


// 获取常见问题详情
export function qaInfo(data) {
  return request({
    url: '/qa/getDetail',
    method: 'get',
	params:data
  })
}



// 获取底部列表
export function footerList() {
  return request({
    url: '/footer/getList',
    method: 'get'
  })
}




// 获取新闻列表
export function getNewslist(data) {
  return request({
    url: '/news/getList',
    method: 'post',
	data:data
  })
}



// 获取商品详情
export function getNewsInfo(data) {
  return request({
    url: '/news/getDetail',
    method: 'get',
	params:data
  })
}